import { AnswerInterface, ArrayHelper, DesignerData, EnvironmentHelper, QuestionInterface } from ".";
import { FileHelper } from "./FileHelper";

export class AnswerHelper {

  static buildQuestionTree = (allQuestions: QuestionInterface[], parentId: number) => {
    const result: QuestionInterface[] = ArrayHelper.getAll(allQuestions, "parentId", parentId);
    result.forEach(r => {
      const children = AnswerHelper.buildQuestionTree(allQuestions, r.id);
      if (children.length > 0) r.children = children;
    })
    return result;
  }

  static preSaveDesignerImages = async (json: string, ts: string, contentType: string, contentId: number, questionId: number, progressCallback: (percent: number) => void) => {
    const data: DesignerData = JSON.parse(json);
    let i = 0;
    for (let scene of data.scenes) {
      for (let element of scene.elements) {
        if (element.type === "image" && element.url.indexOf("data:image/") > -1) {
          const f = FileHelper.dataURLtoFile(element.url, ts + "-" + i + ".png");
          let key = await FileHelper.preUpload(contentType, contentId, questionId, f, f.name, progressCallback);
          element.url = EnvironmentHelper.ContentRoot + "/" + key;
        }
        i++;
      }
    }
    return JSON.stringify(data);
  }

  static preSave = async (answers: AnswerInterface[], questions: QuestionInterface[], progressCallback: (percent: number) => void) => {
    if (answers.length > 0) {
      let contentType = "message";
      let contentId = answers[0].messageId;
      if (answers[0].playlistId) {
        contentType = "playlist";
        contentId = answers[0].playlistId;
      }
      if (answers[0].overlayId) {
        contentType = "overlay";
        contentId = answers[0].overlayId;
      }
      const ts = new Date().getTime().toString();

      for (let a of answers) {

        const q: QuestionInterface = ArrayHelper.getOne(questions, "id", a.questionId);
        if (q) {
          switch (q.fieldType) {
            case "array":
              if (a.value.startsWith("[") || a.value.startsWith("{")) {
                const f = FileHelper.createJson(a.value);
                let key = await FileHelper.preUpload(contentType, contentId, q.id, f, f.name, progressCallback);
                a.value = EnvironmentHelper.ContentRoot + "/" + key;
              }
              break;
            case "image":
              if (a.value.startsWith("data:")) {
                const f = FileHelper.dataURLtoFile(a.value, ts + ".png");
                let key = await FileHelper.preUpload(contentType, contentId, q.id, f, f.name, progressCallback);
                a.value = EnvironmentHelper.ContentRoot + "/" + key;
              }
              break;
            case "designer":
              if (!a.value.startsWith("http")) {
                const json = await AnswerHelper.preSaveDesignerImages(a.value, ts, contentType, contentId, q.id, progressCallback);
                const f = FileHelper.stringToFile(json, "application/json", ts + ".json");
                let key = await FileHelper.preUpload(contentType, contentId, q.id, f, f.name, progressCallback);
                a.value = EnvironmentHelper.ContentRoot + "/" + key;
              }
              break;
            case "file":
              if (a.value === "Pending Upload") {
                const fileId = "question" + a.questionId + "file";
                const field = document.getElementById(fileId) as HTMLInputElement;
                const f = field.files[0];
                let key = await FileHelper.preUpload(contentType, contentId, q.id, f, f.name, progressCallback);
                a.value = EnvironmentHelper.ContentRoot + "/" + key;
              }
              break;
            case "file[]":

              const values = a.value?.split("`");
              if (values.length > 0) {
                if (values[values.length - 1] === "Pending Upload") {
                  values.splice(values.length - 1, 1);
                  const fileId = "question" + a.questionId + "file";
                  const field = document.getElementById(fileId) as HTMLInputElement;
                  let idx = 1;
                  for (let f of field.files) {
                    let key = await FileHelper.preUpload(contentType, contentId, q.id, f, f.name, progressCallback, idx, field.files.length);
                    values.push(EnvironmentHelper.ContentRoot + "/" + key);
                    idx++;
                  }
                }
              }
              a.value = values.join("`");
              break;
            case "video":
            case "silentVideo":
              if (a.value === "Pending Upload") {
                const fileId = "question" + a.questionId + "file";
                const field = document.getElementById(fileId) as HTMLInputElement;
                const f = field.files[0];
                await FileHelper.preUpload(contentType, contentId, q.id, f, "upload.mp4", progressCallback);
                a.value = EnvironmentHelper.PlayerRoot + "/images/processing.mp4";
              }
              break;
          }
        }

      }
    }

  }

}

